<mat-form-field mat-input-height-small>
  <input
    #columnNameInput
    gtm="onTextField"
    gtmAction="Set column name"
    gtmCategory="kanbanBoard"
    [errorStateMatcher]="matcher"
    [maxLength]="MAX_COLUMN_NAME_LENGTH"
    [gtmOn]="['change', 'focus', 'blur']"
    [formControl]="nameForm"
    (keydown)="onKeyDown($event)"
    (blur)="onBlurEvent()"
    type="text"
    matInput
    required
  />
  <mat-error *ngIf="nameForm.errors?.required">
    {{ '+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.COLUMN_NAME_INPUT_EMPTY' | translate }}
  </mat-error>
  <mat-error *ngIf="nameForm.errors?.notUnique">
    {{ '+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.COLUMN_NAME_INPUT_TAKEN' | translate }}
  </mat-error>
</mat-form-field>
